import {FullTableMap} from 'notebook/tables/excess/Evaluator';
import {Table, TableOpDiff, TableOpDiffMap} from 'notebook/tables/TableConstants';

export function countSelectors(documentParts: Array<{table?: Table | null}>): Record<string, number> {
  const usageCounts: {[selectorId: string]: number} = {};
  documentParts
    .filter((documentPart) => documentPart.table != null)
    .forEach(({table}) => {
      table!.table.forEach((row) => {
        row.forEach(({selectorId}) => {
          if (selectorId == null) {
            return;
          }
          if (!usageCounts[selectorId]) {
            usageCounts[selectorId] = 0;
          }
          usageCounts[selectorId] += 1;
        });
      });
    });
  return usageCounts;
}

/**
 * Returns all table cells in the specified fullTableMap that are assigned a selector ID.
 */
export function getCellsWithSelectors(fullTableMap: FullTableMap): TableOpDiffMap | null {
  const result: TableOpDiffMap = {};
  Object.keys(fullTableMap).forEach((tableName) => {
    const tableOp: TableOpDiff = {type: 'update-cells', cells: []};
    fullTableMap[tableName].table.forEach((tableRow, row) => {
      tableRow.forEach((cell, column) => {
        if (cell.selectorId != null) {
          tableOp.cells.push({row, column});
        }
      });
    });
    if (tableOp.cells.length > 0) {
      result[tableName] = tableOp;
    }
  });
  return Object.keys(result).length > 0 ? result : null;
}
